export default __webpack_public_path__ + "static/media/TrustWallet.f390ad84.svg";